export class QuotesV3FieldsEnvironment {
  public static getName = () => 'benzinga-quotes-v3-fields';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env['url'] ?? 'https://www.benzinga.com/api/sheets/quoteFields'),
  });
}
